export default {
    product: {
        description: {
            more: "more"
        }
    }
}